import React from "react";

function ModeButton(props) {
    const { changeMode } = props;

    const handleClick = () => {
        changeMode();
    };

    return (
        <li className="fl display_btn1" onClick={handleClick}>
            <button type="button" className="light"></button>
        </li>
    );
}

export default ModeButton;
